import { formatCurrency } from '@bodilenergy/util';

import { BodilColor } from '~src/branding';
import {
  AddressWithMap,
  EstimateBookingPanel,
  HeaderStreamer,
  LoanDisclaimer,
  OfferTypeSelector,
  SavingsEstimate,
  SuggestionBanner,
  TakeoverOverlay,
} from '~src/components/EstimatePage';
import { CalculatorHeader } from '~src/components/Header/CalculatorHeader';
import { Root } from '~src/components/Root';
import { Heading } from '~src/components/Typography';
import { EstimatePageProps } from '~src/model';

import {
  BackgroundImage,
  BackgroundShading,
  DesktopLeftSide,
  DesktopRightSide,
  DesktopRightSideContent,
  STANDARD_MARGIN,
} from './style';
import { getBookingFormVariant } from './util';

export const EstimatePageDesktopBodil = (props: EstimatePageProps) => {
  const { address, disabledProducts, fuelType, products, financing, savings, showLoan, setShowLoan, hasBbrData } =
    props;
  const bookingFormVariant = getBookingFormVariant();

  return (
    <Root
      footer={false}
      header={<CalculatorHeader />}
      pageStyle={{
        display: 'flex',
        paddingLeft: 0,
        paddingRight: 0,
      }}
    >
      <DesktopLeftSide>
        <EstimateBookingPanel
          variant={bookingFormVariant}
          style={{ paddingLeft: STANDARD_MARGIN, paddingRight: STANDARD_MARGIN }}
          defaultTitle={
            <Heading
              style={{
                fontSize: '24px',
                maxWidth: '80%',
                alignSelf: 'start',
              }}
            >
              Book et møde med en energirådgiver i dag, og få{' '}
              <span style={{ color: BodilColor.ui.orange }}>{formatCurrency(2000, { decimals: 0 })}</span> rabat på din
              ordre ved køb inden for de næste 30 dage
            </Heading>
          }
        />
      </DesktopLeftSide>

      <DesktopRightSide>
        <BackgroundImage />

        <BackgroundShading />

        <DesktopRightSideContent>
          <OfferTypeSelector
            style={{ position: 'absolute', right: '5%' }}
            backgroundStyle={{ borderRadius: '0 0 16px 16px' }}
            fuelType={fuelType}
          />

          <AddressWithMap
            style={{
              paddingTop: '20px',
              marginLeft: STANDARD_MARGIN,
            }}
            address={address}
          />

          <HeaderStreamer
            style={{
              marginTop: '16px',
              marginLeft: STANDARD_MARGIN,
              marginRight: STANDARD_MARGIN,
              height: '100px',
            }}
            totalSaved={savings?.saved.price}
            showLoan={showLoan}
          />

          <SavingsEstimate
            showLoan={showLoan}
            setShowLoan={setShowLoan}
            savings={savings}
            products={products}
            style={{
              height: '280px',
              marginLeft: STANDARD_MARGIN,
              marginRight: STANDARD_MARGIN,
            }}
            financing={financing}
          />

          <div style={{ marginBottom: 0, height: 'fit-content' }}>
            {showLoan ? (
              <LoanDisclaimer
                style={{
                  marginBottom: '16px',
                  paddingLeft: STANDARD_MARGIN,
                  paddingRight: STANDARD_MARGIN,
                  height: '30px',
                }}
              />
            ) : (
              <div style={{ height: '46px' }} />
            )}

            <SuggestionBanner
              style={{ paddingLeft: STANDARD_MARGIN, paddingRight: STANDARD_MARGIN }}
              products={products}
            />
          </div>

          {(!hasBbrData || disabledProducts.length > 1) && (
            <TakeoverOverlay
              address={address}
              style={{
                marginLeft: STANDARD_MARGIN,
                marginRight: STANDARD_MARGIN,
              }}
            />
          )}
        </DesktopRightSideContent>
      </DesktopRightSide>
    </Root>
  );
};
